













import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_ameldingsInYear_ameldings_paychecks } from '@/queries/__generated__/ameldingsInYear';

@Component
export default class AmeldingListPaycheck extends Vue {
  @Prop({ type: Object, required: true }) private paycheck!: GQL_ameldingsInYear_ameldings_paychecks;
}
